<template>
    <div class="categories" v-if="$can('category_view')">
      <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
        <span>{{ message }}</span>
      </v-snackbar>
    <div class="pa-5">
        <v-layout column>
          <div v-if="view == 'default'">
            <v-card elevation="0" class="mt-5">
              
              <v-flex xs12 class="mt-10 mb-2">
                <div class="mx-5">
                  <v-layout row wrap>
                    <v-flex xs12 md6> 
                        <div v-if="length != 0" align="left" class="mt-1">
                            <b class="display-1 primary--text">Total: </b
                            >{{ categoryPagination.total | formatNumber }}
                        </div>
                    </v-flex>
                    <v-flex xs12 md4>
                      <div class="pa-1">
                        <v-text-field
                          class="text_field background"
                          outlined
                          dense
                          rounded
                          label="Search"
                          append-icon="mdi-undo-variant"
                          @click:append="resetSearch()"
                          v-on:keyup.enter="search"
                          v-model="searchTerm"
                          @input="enableSearch()"
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <v-flex xs12 md2>
                      <div class="pa-1" align="right">
                        <v-btn
                          class="button mx-1"
                          icon
                          @click="search"
                          :loading="searchLoader"
                          :disabled="searchButtonDisabled"
                        >
                          <v-icon class="secondary--text">mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                          class="button mx-1"
                          @click="changeView('create')"
                          v-if="$can('category_create')"
                        >
                        
                          <v-icon class="primary--text">mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-divider class="mt-9 mx-5"></v-divider>
              <v-progress-linear
                v-if="categoryLoader"
                height="1"
                indeterminate
                color="primary"
              >
              </v-progress-linear>
              <v-flex xs12 class="mt-5">
                <div v-if="categories.length == 0">
                  <v-card elevation="0">
                    <v-layout row wrap>
                      <v-flex xs12 md1>
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col class="text-center">
                              <v-icon large class="primary--text">
                                mdi-alert-circle-outline
                              </v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 md11>
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col class="text-center">
                              No Category Found
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </div>
                <div v-else>
                  <div class="hidden-sm-and-down">
                    <v-card elevation="0" class="pa-2">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead class="header">
                            <tr class="accent">
                              <th class="text-left text--text">Name</th>
                              <th class="text-left text--text">Status</th>
                              <th class="text-left text--text">Date Created</th>
                              <th class="text-right text--text">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in categories" :key="item.id">
                              
                              <td>{{ item.name }}</td>                             
                              <td>
                                <div v-if="item.status == 1">Active</div>
                                <div v-else>Inactive</div>
                              </td>
                              <td>
                                {{
                                  item.created_at | moment("DD/MM/YYYY - hh:mm a")
                                }}
                              </td>
                              <td>
                                <div align="right">
                                  <v-btn
                                    icon
                                    v-if="$can('category_view')"
                                    @click="showCategory(item)"
                                    class="button mr-1 universal--text"
                                  >
                                    <v-icon small> mdi-eye </v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="$can('category_edit')"
                                    icon
                                    class="button mr-1 success--text"
                                    @click="editCategory(item)"
                                  >
                                    <v-icon small> mdi-pencil </v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="$can('category_archive')"
                                    icon
                                    class="button mr-1 error--text"
                                    @click="deleteCategory(item)"
                                    :loading="
                                      loading && categoryIndex == item.id
                                    "
                                  >
                                    <v-icon small> mdi-delete </v-icon>
                                  </v-btn>
                                  <v-tooltip
                                    top
                                    v-if="
                                      $can('category_activate') &&
                                      item.status == 0
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 red--text"
                                        @click="activateCategory(item)"
                                        :loading="
                                          activateLoading &&
                                          categoryIndex == item.id
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small>
                                          mdi-toggle-switch-off-outline
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Activate Category</span>
                                  </v-tooltip>
                                  <v-tooltip
                                    top
                                    v-if="
                                      $can('category_deactivate') &&
                                      item.status == 1
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 green--text"
                                        @click="deactivateCategory(item)"
                                        :loading="
                                          deactivateLoading &&
                                          categoryIndex == item.id
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small> mdi-toggle-switch </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Deactivate Category</span>
                                  </v-tooltip>
                                  <v-tooltip top v-if="$can('log_view')">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 purple--text"
                                        @click="viewLog(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small> mdi-script-text </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Log</span>
                                  </v-tooltip>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </div>
                  <div class="hidden-md-and-up">
                    <div>
                      <v-layout column>
                        <template v-for="(category, index) in categories">
                          <div :key="index">
                            <v-flex xs12 class="mb-2">
                              <v-card elevation="0" style="border-radius: 25px;" outlined>
                                <div class="pa-5">
                                  <v-layout column>
                                    <v-flex xs12>
                                      <v-layout row wrap>
                                        <v-flex xs11>
                                          <div class="title primary--text">
                                            <b>{{ category.name }}</b>
                                          </div>
                                        </v-flex>
                                        <v-flex xs1>
                                          <v-btn
                                            depressed
                                            class="red--text"
                                            :loading="
                                              loading &&
                                              categoryIndex == category.id
                                            "
                                            icon
                                            @click="
                                              deleteCategory(category)
                                            "
                                            v-if="$can('category_archive')"
                                          >
                                            <v-icon> mdi-delete </v-icon>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-divider class="mt-2"></v-divider>
                                    <v-flex xs12 class="mt-1">
                                      <v-layout column>
                                       
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs4>
                                              <b>Status</b>
                                            </v-flex>
                                            <v-flex xs8>
                                              <div v-if="category.status == 1">Active</div>
                                              <div v-else>Inactive</div>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs4>
                                              <b>Date Created</b>
                                            </v-flex>
                                            <v-flex xs8>
                                              {{
                                                category.created_at
                                                  | moment("DD/MM/YYYY - hh:mm a")
                                              }}
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs12 v-if="$can('category_view')">
                                              <div>
                                                <v-btn
                                                rounded
                                                  depressed
                                                  class="primary text-none white--text mt-3"
                                                  block
                                                  @click="
                                                    showCategory(category)
                                                  "
                                                  
                                                  >View
                                                  <v-icon right> mdi-eye </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('category_edit')">
                                              <div>
                                                <v-btn
                                                rounded
                                                  depressed
                                                  class="blue text-none white--text mt-1"
                                                  block
                                                  @click="
                                                    editCategory(category)
                                                  "
                                                  
                                                  >Edit
                                                  <v-icon right>
                                                    mdi-border-color
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('category_activate') &&
                                                    category.status == 0">
                                              <div>
                                                <v-btn
                                                rounded
                                                  depressed
                                                  class="green text-none white--text mt-1"
                                                  block
                                                  :loading="
                                                    activateLoading &&
                                                    categoryIndex == category.id
                                                  "
                                                  @click="
                                                    activateCategory(category)
                                                  "
                                                  
                                                  >Activate Category
                                                  <v-icon right>
                                                    mdi-toggle-switch-off-outline
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('category_deactivate') &&
                                                    category.status == 1">
                                              <div>
                                                <v-btn
                                                rounded
                                                  depressed
                                                  class="red text-none white--text mt-1"
                                                  block
                                                  :loading="
                                                    deactivateLoading &&
                                                    categoryIndex == category.id
                                                  "
                                                  @click="
                                                    deactivateCategory(category)
                                                  "
                                                  
                                                  >Deactivate Category
                                                  <v-icon right>
                                                    mdi-toggle-switch
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('log_view')" >
                                              <div class="mt-1">
                                                <v-btn
                                                  rounded
                                                  block
                                                  depressed
                                                  class="purple text-none white--text"
                                                  @click="viewLog(category)"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                > Log
                                                  <v-icon small> mdi-script-text </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-card>
                            </v-flex>
                          </div>
                        </template>
                      </v-layout>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-card>
            <v-layout column class="mt-5">
              <v-flex xs12>
                <div align="left">
                  <v-pagination
                    v-if="length != 0"
                    :length="length"
                    total-visible="10"
                    v-model="categoryPagination.current_page"
                    @input="changePage()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-flex>
              
            </v-layout>
          </div>
          <div v-if="view == 'create'">
            <v-flex class="mt-5">
              <v-card outlined>
                <v-card-title class="accent text--text">
                  <v-img
                    v-if="newCategory.id != null"
                    src="img/badge.png"
                    max-width="40"
                  ></v-img>
                  <v-spacer></v-spacer>
                  <div v-if="newCategory.id == null">Add Category</div>
                  <div v-else>Edit Category</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="changeView('default')">
                    <v-icon class="text--text"> mdi-close </v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-form v-model="valid" ref="form" lazy-validation>
                    <v-layout row wrap class="mt-5">
                      <v-flex xs12 md4>
                        <div class="pa-3">
                          <div>Name<span class="error--text">*</span></div>
                          <v-text-field
                            class="text_field background my-2"
                            outlined
                            dense
                            v-model="newCategory.name"
                            :rules="inputRules"
                          ></v-text-field>
                        </div>
                      </v-flex>
                  
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    class="primary text-none mt-3"
                    @click="save"
                    :disabled="!valid"
                    :loading="loading"
                  >
                    Save
                    <v-icon right> mdi-content-save </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </div>
          <div v-if="view == 'show'">
            <v-card outlined class="mt-5">
              <v-progress-linear
                v-if="subCategoryLoader"
                height="1"
                indeterminate
                color="primary"
              >
              </v-progress-linear>
              <v-card-title class="accent text--text">
                <v-spacer></v-spacer>
                <div>View Category</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon> mdi-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <div class="pa-1">
                  <v-tabs show-arrows v-model="categoryTab">
                    <v-tabs-slider color="primary"></v-tabs-slider>
  
                    <v-tab @click="activeTab = 'details'">
                      <div class="text-none primary--text">Details</div>
                    </v-tab>
                    <v-tab v-if="$can('sub_category_view')"
                      @click="activeTab = 'subCategories'"
                    >
                      <div class="text-none primary--text">
                        Sub Categories ({{
                          subCategoryPagination.total
                        }})
                      </div>
                    </v-tab>
                  </v-tabs>
                  <div v-if="activeTab == 'details'">
                    <v-card-text>
                      <div class="pa-3">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-layout column class="mt-3">
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 md6>
                                    <v-layout column>
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Category Name: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div>
                                              {{ assignedCategory.name }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Status: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div
                                              v-if="
                                                assignedCategory.status == 1
                                              "
                                            >
                                              Active
                                            </div>
                                            <div v-else>Inactive</div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 md6>
                                    <v-layout column>
                                      
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Date Created: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div>
                                              {{
                                                assignedCategory.created_at
                                                  | moment("DD/MM/YYYY - hh:mm a")
                                              }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card-text>
                  </div>
  
                  <div v-if="activeTab == 'subCategories'">
                    <div v-if="subCategoryView == 'default'">
                      <v-card elevation="0" class="mt-5">
                        <v-flex xs12 class="mt-10 mb-2">
                          <div class="mx-5">
                            <v-layout row wrap>
                              <v-flex xs12 md6>
                                <div
                                    v-if="subCategoryLength != 0"
                                    align="left"
                                    class="mt-1"
                                >
                                    <b class="display-1 primary--text">Total: </b
                                    >{{
                                    subCategoryPagination.total
                                        | formatNumber
                                    }}
                                </div>
                              </v-flex>
                              <v-flex xs12 md4>
                                <div class="pa-1">
                                  <v-text-field
                                    class="text_field background"
                                    outlined
                                    dense
                                    rounded
                                    label="Search"
                                    append-icon="mdi-undo-variant"
                                    @click:append="
                                      resetSubCategorySearch()
                                    "
                                    v-on:keyup.enter="
                                      subCategorySearch
                                    "
                                    v-model="subCategorySearchTerm"
                                    @input="
                                      enableSubCategorySearch()
                                    "
                                  ></v-text-field>
                                </div>
                              </v-flex>
                              <v-flex xs12 md2>
                                <div class="pa-1" align="right">
                                  <v-btn
                                    class="button mx-1"
                                    icon
                                    @click="subCategorySearch"
                                    :loading="
                                      subCategorySearchLoader
                                    "
                                    :disabled="
                                      subCategorySearchButtonDisabled
                                    "
                                  >
                                    
                                    <v-icon class="secondary--text">mdi-magnify</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    class="button mx-1"
                                    @click="
                                      changeSubCategoryView(
                                        'create'
                                      )
                                    "
                                    v-if="
                                      $can('sub_category_create')
                                    "
                                  >
                                    <v-icon class="primary--text">mdi-plus-circle-outline</v-icon>
                                  </v-btn>
                                </div>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-flex>
                        <v-divider class="mt-9 mx-5"></v-divider>
                        <v-flex xs12 class="mt-5">
                          <div v-if="subCategories.length == 0">
                            <v-card elevation="0">
                              <v-layout row wrap>
                                <v-flex xs12 md1>
                                  <v-container fill-height fluid>
                                    <v-row align="center" justify="center">
                                      <v-col class="text-center">
                                        <v-icon large class="text--text">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-flex>
                                <v-flex xs12 md11>
                                  <v-container fill-height fluid>
                                    <v-row align="center" justify="center">
                                      <v-col class="text-center">
                                        No Sub Category Found
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </div>
                          <div v-else>
                            <div class="hidden-sm-and-down">
                              <v-card elevation="0" class="pa-2">
                                <v-simple-table>
                                  <template v-slot:default>
                                    <thead class="header">
                                      <tr class="accent">
                                        <th class="text-left text--text">Name</th>
                                        <th class="text-left text--text">Date Created</th>
                                        <th class="text-left text--text">Status</th>
                                        <th class="text-right text--text">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in subCategories"
                                        :key="item.id"
                                      >
                                        <td>
                                          {{ item.name }}
                                        </td>
                                        <td>
                                            {{
                                                item.created_at | moment("DD/MM/YYYY - hh:mm a")
                                            }}
                                        </td>
                                        <td>
                                          <div v-if="item.status == 1">
                                            Active
                                          </div>
                                          <div v-else>Inactive</div>
                                        </td>
                                        <td>
                                          <div align="right">
                                            
                                            <v-btn
                                                v-if="$can('sub_category_edit')"
                                                icon
                                                class="button mr-1 success--text"
                                                @click="editSubCategory(item)"
                                            >
                                                <v-icon small> mdi-pencil </v-icon>
                                            </v-btn>
                                            <v-btn
                                              v-if="
                                                $can(
                                                  'sub_category_archive'
                                                )
                                              "
                                              icon
                                              class="button mr-1 error--text"
                                              @click="
                                                deleteSubCategory(
                                                  item
                                                )
                                              "
                                              :loading="
                                                loading &&
                                                subCategoryIndex ==
                                                  item.id
                                              "
                                            >
                                              <v-icon small> mdi-delete </v-icon>
                                            </v-btn>
                                            <v-tooltip
                                              top
                                              v-if="
                                                $can(
                                                  'sub_category_activate'
                                                ) && item.status == 0
                                              "
                                            >
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  class="button mr-1 red--text"
                                                  @click="
                                                    activateSubCategory(
                                                      item
                                                    )
                                                  "
                                                  :loading="
                                                    activateLoading &&
                                                    subCategoryIndex ==
                                                      item.id
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon small>
                                                    mdi-toggle-switch-off-outline
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Activate Sub Category</span>
                                            </v-tooltip>
                                            <v-tooltip
                                              top
                                              v-if="
                                                $can(
                                                  'sub_category_deactivate'
                                                ) && item.status == 1
                                              "
                                            >
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  class="button mr-1 green--text"
                                                  @click="
                                                    deactivateSubCategory(
                                                      item
                                                    )
                                                  "
                                                  :loading="
                                                    deactivateLoading &&
                                                    subCategoryIndex ==
                                                      item.id
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon small>
                                                    mdi-toggle-switch
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Deactivate Sub Category</span>
                                            </v-tooltip>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card>
                            </div>
                            <div class="hidden-md-and-up">
                              <div>
                                <v-layout column>
                                  <template
                                    v-for="(
                                      part, index
                                    ) in subCategories"
                                  >
                                    <div :key="index">
                                      <v-flex xs12 class="mb-2">
                                        <v-card elevation="0" style="border-radius: 25px;" outlined>
                                          <div class="pa-7 mt-2">
                                            <v-layout column>
                                              <v-flex xs12>
                                                <v-layout row wrap>
                                                  <v-flex xs11>
                                                    <div
                                                      class="title primary--text"
                                                    >
                                                      <b
                                                        >{{
                                                          part.name
                                                        }}</b
                                                      >
                                                    </div>
                                                  </v-flex>
                                                  <v-flex xs1>
                                                    <v-btn
                                                      depressed
                                                      class="red--text"
                                                      :loading="
                                                        loading &&
                                                        subCategoryIndex ==
                                                          part.id
                                                      "
                                                      icon
                                                      @click="
                                                        deleteSubCategory(
                                                          part
                                                        )
                                                      "
                                                      v-if="
                                                        $can(
                                                          'sub_category_archive'
                                                        )
                                                      "
                                                    >
                                                      <v-icon>
                                                        mdi-delete
                                                      </v-icon>
                                                    </v-btn>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                              <v-divider class="mt-2"></v-divider>
                                              <v-flex xs12 class="mt-1">
                                                <v-layout column>
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                      <v-flex xs4>
                                                        <b>Status</b>
                                                      </v-flex>
                                                      <v-flex xs8>
                                                        <div
                                                          v-if="
                                                            part.status ==
                                                            1
                                                          "
                                                        >
                                                          Active
                                                        </div>
                                                        <div v-else>Inactive</div>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                      <v-flex xs4>
                                                        <b>Date Created</b>
                                                      </v-flex>
                                                      <v-flex xs8>
                                                        {{
                                                          part.created_at | moment("DD/MM/YYYY - hh:mm a")
                                                        }}
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
  
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                  
                                                      <v-flex xs12  v-if="
                                                              $can(
                                                                'sub_category_activate'
                                                              ) && part.status == 0
                                                            ">
                                                        <div>
                                                          <v-btn
                                                            rounded
                                                            depressed
                                                            class="green darken-1 text-none white--text mt-1"
                                                            block
                                                            :loading="
                                                              activateLoading &&
                                                              subCategoryIndex ==
                                                                part.id
                                                            "
                                                            @click="
                                                              activateSubCategory(
                                                                part
                                                              )
                                                            "
                                                           
                                                            >Activate Sub Category
                                                            <v-icon right>
                                                              mdi-toggle-switch
                                                            </v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </v-flex>
                                                      <v-flex xs12 v-if="
                                                              $can(
                                                                'sub_category_deactivate'
                                                              ) && part.status == 1
                                                            ">
                                                        <div>
                                                          <v-btn
                                                            rounded
                                                            depressed
                                                            class="red darken-1 text-none white--text mt-1"
                                                            block
                                                            :loading="
                                                              deactivateLoading &&
                                                              subCategoryIndex ==
                                                                part.id
                                                            "
                                                            @click="
                                                              deactivateSubCategory(
                                                                part
                                                              )
                                                            "
                                                            
                                                            >Deactivate Sub Category
                                                            <v-icon right>
                                                              mdi-toggle-switch-off-outline
                                                            </v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </div>
                                        </v-card>
                                      </v-flex>
                                    </div>
                                  </template>
                                </v-layout>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-card>
                      <v-layout column class="mt-5">
                        <v-flex xs12>
                          <div align="left">
                            <v-pagination
                              v-if="length != 0"
                              :length="subCategoryLength"
                              total-visible="10"
                              v-model="
                                subCategoryPagination.current_page
                              "
                              @input="changeSubCategoryPage()"
                              circle
                            >
                            </v-pagination>
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-if="subCategoryView == 'create'">
                      <v-flex class="mt-5">
                        <v-card-title class="accent text--text">
                          <v-spacer></v-spacer>
                          <div v-if="newSubCategory.id == null">
                            Add Sub-Category
                          </div>
                          <div v-else>Edit Sub-Category</div>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon
                            @click="
                              changeSubCategoryView('default')
                            "
                          >
                            <v-icon class="text--text"> mdi-close </v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            v-model="valid"
                            ref="subCategoryForm"
                            lazy-validation
                          >
                            <v-layout row wrap class="mt-5">
                              <v-flex xs12 md4>
                                <div class="pa-3">
                                  <div>
                                    Sub-Category Name<span class="error--text">*</span>
                                  </div>
                                  <v-text-field
                                        class="text_field background my-2"
                                        outlined
                                        dense
                                        v-model="newSubCategory.name"
                                        :rules="inputRules"
                                    ></v-text-field>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            class="primary text-none mt-3"
                            @click="saveSubCategory"
                            :disabled="!valid"
                            :loading="loading"
                          >
                            Save
                            <v-icon right> mdi-content-save </v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-flex>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-layout>
      </div>
      <logData v-if="logDataModel" v-model="logDataModel" />
    </div>
  </template>
  <style>
  .ck-editor__editable {
    min-height: 200px;
  }
  </style>
  <script>
  import Vue from "vue";
  import apiCall from "@/utils/api";
  import { mapGetters, mapState, mapActions } from "vuex";
  import logData from "@/views/accessControl/logData";
  import CKEditor from "@ckeditor/ckeditor5-vue2";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  
  Vue.use(CKEditor);
  
  export default {
    components: {
      logData,
    },
    data() {
      return {
        path: process.env.VUE_APP_API_URL,
  
        editor: ClassicEditor,
        editorConfig: {},
  
        importDialog: false,
        activeTab: "details",
        
        view: "default",
        subCategoryView: "default",
  
        contactView: "default",
        loading: false,
        subCategoryLoader: false,
  
        activateLoading: false,
        deactivateLoading: false,
  
        valid: true,
        message: "",
        color: "",
        delete: false,
        activate: false,
        confirm: false,
        tab: null,
        
        categoryTab: null,
        subCategoryIndex: null,
        categoryIndex: null,
  
        snackbar: false,
        inputRules: [(v) => !!v || "Input is required"],
  
        emailRules: [
          (v) =>
            !v ||
            /^[a-zA-Z0-9\.!#$%&'*+/=?^_~-]+@([a-zA-Z0-9]+\.)+[a-zA-Z]{2,3}$/.test(
              v
            ) ||
            "E-mail must be valid",
          (v) => !v || (v && v.length <= 50) || "Maximum 50 characters",
        ],
        websiteRules: [
          (v) =>
            !v ||
            /^[a-zA-Z0-9\.!#:$%&'*+/=?^_~-]+[a-zA-Z]{2,3}$/.test(v) ||
            "URL must be valid",
          (v) => !v || (v && v.length <= 50) || "Maximum 50 characters",
        ],
  
        items: [],
        searchParts: null,
  
        searchTerm: null,
        subCategorySearchTerm: null,
  
        searchLoader: false,
        searchButtonDisabled: false,
        subCategorySearchButtonDisabled: false,
  
  
        filteredCategories: false,
        filteredCategoryParts: false,
  
        years: [],
        newCategory: {
          id: null,
          name: null,
        },  
        newSubCategory: {
          id: null,
          category_id: null,
          name: null,
        },
  
        assignedCategory: null,
        formData: null,
  
        coverImageDialog: false,
        imageDialog: false,
        imageLoading: false,
        fileRules: [(v) => !!v || this.$t("kindlySelectAFileMsg")],
        imageFile: null,
        imageValid: true,
  
        searchTerm: null,
        searchLoader: false,
        subCategorySearchLoader: false,
  
        searchButtonDisabled: false,
  
        filteredCategories: [],
        subCategories: [],
  
        subCategoryPagination: {
          search: " ",
          current_page: 1,
          per_page: 0,
          total: 0,
          visible: 10,
        },

        
        logData: {
          message: null,
          model: null,
        },
      };
    },
    watch: {
      searchParts(val) {
        val && val !== this.newSubCategory.user_id && this.findPart(val);
      },
    },
    created() {
      if (this.$can("category_view")) {
        this.startCategoryLoader();
        this.fetchCategories(this.categoryPagination.current_page);
        // this.getFormData();
        // this.populateYears();
      }
    },
    methods: {
      ...mapActions([
        "fetchCategories",
        "startCategoryLoader",
        "stopCategoryLoader",
        "filterCategories",
  
        "filterLogData",
        "openLogDataModel",
      ]),
      populateYears() {
        var max = new Date().getFullYear();
        var min = max - 100;
        var years = [];
  
        for (var i = max; i >= min; i--) {
          years.push(i);
        }
        this.years = years;
      },
      findPart(v) {
        this.loading = true;
        
        setTimeout(() => {
          apiCall({
            url: "/api/user?type=search&search=" + this.searchParts,
            method: "GET",
          })
            .then((resp) => {
              this.items = resp.data;
            })
            .catch((error) => {
              this.loading = false;
            });
  
          this.loading = false;
        }, 3000);
      },
  
      showSubCategory(user) {
        this.$router.push("/user/" + user.code);
      },
     
      enableSearch() {
        this.searchButtonDisabled = false;
      },
      
  
      enableSubCategorySearch() {
        this.subCategorySearchButtonDisabled = false;
      },
      
     
      resetSearch() {
        this.searchTerm = null;
        this.filteredCategories = true;
        this.startCategoryLoader();
        this.fetchCategories(1);
      },    
  
      resetSubCategorySearch() {
        this.subCategorySearchTerm = null;
        this.filteredCategoryParts = false;
        this.subCategoryLoader = false;
        this.changeSubCategoryPage();
      },

      changeSubCategoryPage() {
        this.subCategoryLoader = true;
        if (this.filteredCategoryParts == true) {
          this.subCategorySearchButtonDisabled = false;
          apiCall({
            url:
              "/api/sub-category?category_id=" +
              this.assignedCategory.id +
              "&page=" +
              this.subCategoryPagination.current_page +
              "&type=search&search=" +
              this.subCategorySearchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.subCategoryLoader = false;
  
              this.subCategories = resp.data;
              this.subCategoryPagination.current_page =
                resp.current_page;
              this.subCategoryPagination.total = resp.total;
              this.subCategoryPagination.per_page = resp.per_page;
            })
            .catch((error) => {
              console.log(error);
              this.subCategoryLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        } else {
          apiCall({
            url:
              "/api/sub-category?category_id=" +
              this.assignedCategory.id +
              "&page=" +
              this.subCategoryPagination.current_page,
            method: "GET",
          })
            .then((resp) => {
              this.subCategoryLoader = false;
  
              this.subCategories = resp.data;
              this.subCategoryPagination.current_page =
                resp.current_page;
              this.subCategoryPagination.total = resp.total;
              this.subCategoryPagination.per_page = resp.per_page;
            })
            .catch((error) => {
              console.log(error);
              this.subCategoryLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        }
      },
      
      getText(item) {
        return (
          item.first_name + " " + item.middle_name + " " + item.last_name + " #" + item.code
        );
      },
      showCategory(category) {
        this.assignedCategory = category;

        this.changeSubCategoryPage();
        this.changeView("show");
      },
  
      editCategory(category) {
        this.newCategory.id = category.id;
        this.newCategory.name = category.name;
  
        console.log("this.newCategory", this.newCategory)
  
        this.changeView("create");
      },

      editSubCategory(subCategory) {
        this.newSubCategory.id = subCategory.id;
        this.newSubCategory.name = subCategory.name;
  
        console.log("this.newSubCategory", this.newSubCategory)
  
        this.changeSubCategoryView("create");
      },
  
      save() {
        if (this.$refs.form.validate()) {
          if (this.newCategory.id != null) {
            confirm("Are you sure you want to update category?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/category/" + this.newCategory.id,
                data: this.newCategory,
                method: "PUT",
              })
                .then((resp) => {
                  this.message = "Category Updated Successfully";
                  this.color = "orange";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeView("default");
                  this.fetchCategories(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                });
            }
          } else {
            confirm("Are you sure you want to create category?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/category",
                data: this.newCategory,
                method: "POST",
              })
                .then((resp) => {
                  this.message = "Category Added Successfully";
                  this.color = "success";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeView("default");
                  this.fetchCategories(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                  this.changeView("default");
                  this.fetchCategories(1);
                });
            }
          }
        }
      },
  
      saveSubCategory() {
        if (this.$refs.subCategoryForm.validate()) {
            if (this.newSubCategory.id != null) {
            confirm("Are you sure you want to update sub category?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/sub-category/" + this.newSubCategory.id,
                data: this.newSubCategory,
                method: "PUT",
              })
                .then((resp) => {
                  this.message = "Sub-Category Updated Successfully";
                  this.color = "orange";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeSubCategoryView("default");
                  this.changeSubCategoryPage(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                });
            }
          } else {


          confirm("Are you sure you want to add Sub-Category?") &&
            (this.confirm = true);
          if (this.confirm) {
            this.loading = true;
            this.newSubCategory.category_id = this.assignedCategory.id;
            apiCall({
              url: "/api/sub-category",
              data: this.newSubCategory,
              method: "POST",
            })
              .then((resp) => {
                this.message = "Category Part Added Successfully";
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.confirm = false;
                this.newSubCategory.user_id = null;
                this.changeSubCategoryView("default");
                this.changeSubCategoryPage();
              })
              .catch((error) => {
                this.message = "An Error Occurred";
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              });
          }
        }
        }
      },
  
      search() {
        if (this.searchTerm == null) {
          this.searchButtonDisabled = true;
        } else {
          this.searchLoader = true;
          this.searchButtonDisabled = false;
          this.startCategoryLoader();
          apiCall({
            url: "/api/category?type=search&search=" + this.searchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.filterCategories(resp);
              this.searchLoader = false;
              this.stopCategoryLoader();
              this.filteredCategories = true;
            })
            .catch((error) => {
              console.log(error);
              this.searchLoader = false;
              this.stopCategoryLoader();
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        }
      },
      
  
      subCategorySearch() {
        if (this.subCategorySearchTerm == null) {
          this.subCategorySearchButtonDisabled = true;
        } else {
          this.subCategorySearchLoader = true;
          this.subCategorySearchButtonDisabled = false;
          this.startCategoryLoader();
          apiCall({
            url:
              "/api/sub-category?type=search&search=" +
              this.subCategorySearchTerm +
              "&category_id=" +
              this.assignedCategory.id,
            method: "GET",
          })
            .then((resp) => {
              this.subCategories = resp.data;
              this.subCategoryPagination.current_page =
                resp.current_page;
              this.subCategoryPagination.total = resp.total;
              this.subCategoryPagination.per_page = resp.per_page;
  
              this.subCategorySearchLoader = false;
              this.filteredCategoryParts = true;
            })
            .catch((error) => {
              this.subCategorySearchLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              console.log(error);
            });
        }
      },
      activateCategory(item) {
        confirm("Are You Sure You Want to Activate Category?") &&
          (this.activate = true);
        if (this.activate) {
          this.activateLoading = true;
          this.categoryIndex = item.id;
          this.newCategory.id = item.id;
          apiCall({
            url: "/api/category?type=activate",
            data: this.newCategory,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Category Account Activated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.categoryIndex = null;
              this.newCategory.id = null;
              this.fetchCategories(this.categoryPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.categoryIndex = null;
              this.newCategory.id = null;
              console.log(error);
            });
        }
      },
      deactivateCategory(item) {
        confirm("Are You Sure You Want to Deactivate Category?") &&
          (this.activate = true);
        if (this.activate) {
          this.deactivateLoading = true;
          this.categoryIndex = item.id;
          this.newCategory.id = item.id;
          apiCall({
            url: "/api/category?type=deactivate",
            data: this.newCategory,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Category Account Deactivated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.categoryIndex = null;
              this.newCategory.id = null;
              this.fetchCategories(this.categoryPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.categoryIndex = null;
              this.newCategory.id = null;
              console.log(error);
            });
        }
      },
     
      activateSubCategory(item) {
        confirm(
          "Are You Sure You Want to Activate Category Part?"
        ) && (this.activate = true);
        if (this.activate) {
          this.activateLoading = true;
          this.subCategoryIndex = item.id;
          this.newSubCategory.id = item.id;
          apiCall({
            url: "/api/sub-category?type=activate",
            data: this.newSubCategory,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Category Part Activated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.subCategoryIndex = null;
              this.newSubCategory.id = null;
              this.changeSubCategoryPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.subCategoryIndex = null;
              this.newSubCategory.id = null;
              console.log(error);
            });
        }
      },
  
      deactivateSubCategory(item) {
        confirm(
          "Are You Sure You Want to Deactivate Category Part?"
        ) && (this.activate = true);
        if (this.activate) {
          this.deactivateLoading = true;
          this.subCategoryIndex = item.id;
          this.newSubCategory.id = item.id;
          apiCall({
            url: "/api/sub-category?type=deactivate",
            data: this.newSubCategory,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Category Part Deactivated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.subCategoryIndex = null;
              this.newSubCategory.id = null;
              this.changeSubCategoryPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.subCategoryIndex = null;
              this.newSubCategory.id = null;
              console.log(error);
            });
        }
      },
      
      changeView(view) {
        if (view == "default") {
          this.newCategory.id = null;
          this.newCategory.name = null;
          this.newCategory.category_type_id = null;
          this.newCategory.county_id = null;
          this.newCategory.brief = null;
          this.newCategory.physical_address = null;
        } else if (view == "create") {
        //   this.getFormData();
        } else if (view == "show") {
        }
        this.view = view;
      },     
  
      changeSubCategoryView(view) {
        if (view == "default") {
          this.newSubCategory.id = null;
          this.newSubCategory.category_id = null;
          this.newSubCategory.name = null;
        } else if (view == "create") {
        } else if (view == "show") {
        }
        this.subCategoryView = view;
      },
      
      changePage() {
        this.startCategoryLoader();
        if (this.filteredCategories == true) {
          this.searchButtonDisabled = false;
          apiCall({
            url:
              "/api/category?page=" +
              this.categoryPagination.current_page +
              "&type=search&search=" +
              this.searchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.filterCategories(resp);
              this.stopCategoryLoader();
            })
            .catch((error) => {
              console.log(error);
              this.stopCategoryLoader();
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        } else {
          this.fetchCategories(this.categoryPagination.current_page);
        }
      },
      deleteCategory(item) {
        confirm("Are You Sure You Want to Delete Category") &&
          (this.delete = true);
        if (this.delete) {
          this.loading = true;
          this.categoryIndex = item.id;
          apiCall({ url: "/api/category/" + item.id, method: "DELETE" })
            .then((resp) => {
              this.message = "Category Deleted Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.categoryIndex = null;
              this.fetchCategories(this.categoryPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.categoryIndex = null;
              console.log(error);
            });
        }
      },
  
      deleteSubCategory(item){
        confirm("Are You Sure You Want to Delete Sub Category?") &&
          (this.delete = true);
        if (this.delete) {
          this.loading = true;
          this.subCategoryIndex = item.id;
          apiCall({
            url: "/api/sub-category/" + item.id,
            method: "DELETE",
          })
            .then((resp) => {
              this.message = "Sub Category Deleted Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.subCategoryIndex = null;
              this.changeSubCategoryPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.subCategoryIndex = null;
              console.log(error);
            });
        }
      },
      
    //   getFormData() {
    //     apiCall({
    //       url: "/api/category?type=formData",
    //       method: "GET",
    //     })
    //       .then((resp) => {
    //         this.formData = resp;
    //       })
    //       .catch((error) => {
    //         this.message = "anErrorOccurredCouldntGetFormDataMsg";
    //         this.color = "error";
    //       });
    //   },
      viewLog(data) {
        this.logData.message = data.id;
        this.logData.model = "App\\Models\\Category";
        this.filterLogData(this.logData);
        this.openLogDataModel();
      },
    },
    computed: {
      ...mapGetters([
        "categories",
        "categoryPagination",
        "categoryLoader",
        "logDataModel"
      ]),
      length: function () {
        return Math.ceil(
          this.categoryPagination.total / this.categoryPagination.per_page
        );
      },
      subCategoryLength: function () {
        return Math.ceil(
          this.subCategoryPagination.total /
            this.subCategoryPagination.per_page
        );
      },
    
      dateToday() {
        var today = new Date();
  
        var timestamp =
          today.getFullYear() +
          "-" +
          this.months[today.getMonth()] +
          "-" +
          ("0" + today.getDate()).slice(-2);
        return timestamp;
      },
    },
  };
  </script>
  